export const recaptchaSignupRequest = (data = {}) => {
  const { recaptchaToken, ...payload } = data;
  const headers = {};

  if (recaptchaToken) {
    headers["x-recaptcha-token"] = recaptchaToken;
  }

  return { data: payload, headers };
};

export const getSignupErrorMessage = (
  err,
  fallback = "Registration failed. Please try again."
) => err?.message || fallback;
